export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/updateAgent',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allAgents'],
    })
